import { assertEvent, assign } from 'xstate5';

import { getActiveRecentDeliveryLocation, getActiveRecentLocation } from '../../../actions';
import {
  type Location,
  type LocationGroups,
  type LocationSearchMachineAction,
  type PositionCoordinates,
} from '../../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const onRecentAndNearbyLocationsDone: LocationSearchMachineAction<RecentAndNearbyLocationsOutput> =
  assign((_, params) => ({
    currentPosition: params.currentPositionCoordinates,
    recentLocations: params.recentLocations,
    nearbyLocations: params.nearbyLocations,
  }));

export const onNearbyLocationsDone: LocationSearchMachineAction<NearbyLocationsOutput> = assign(
  (_, params) => ({
    currentPosition: params.currentPositionCoordinates,
    nearbyLocations: params.nearbyLocations,
  }),
);

export const setActiveRecentLocation: LocationSearchMachineAction = assign(({ context, event }) => {
  assertEvent(event, ['NAVIGATE_TO_RECENT_PICKUP_LOCATION', 'NAVIGATE_TO_RECENT_OUTPOST_LOCATION']);

  return { activeLocation: getActiveRecentLocation(context, event) };
});

export const setActiveRecentDeliveryLocation: LocationSearchMachineAction = assign(
  ({ context, event }) => {
    assertEvent(event, 'NAVIGATE_TO_RECENT_DELIVERY_LOCATION');

    return { deliveryLocation: getActiveRecentDeliveryLocation(context, event) };
  },
);

// ─── Types ───────────────────────────────────────────────────────────────────

type RecentAndNearbyLocationsOutput = {
  currentPositionCoordinates: PositionCoordinates | undefined;
  recentLocations: Location[];
  nearbyLocations: LocationGroups;
};

type NearbyLocationsOutput = {
  currentPositionCoordinates: PositionCoordinates | undefined;
  nearbyLocations: LocationGroups;
};
